<div class="code-block">
  <pre><code>{{ content() }}</code></pre>
</div>
